import IMask from "imask";
import { load } from "./events/events";

load(() => {
  // Маска для текстового поля з обмеженням до 100 символів
  document.querySelectorAll('input[type="text"]').forEach((input) => {
    IMask(input, {
      mask: /^[a-zA-Zа-яА-ЯёЁіІїЇєЄ\s]*$/, // тільки текст
      lazy: false, // показує маску
      maxLength: 100,
    });

    input.addEventListener("input", () => {
      if (input.value.length > 3) {
        input.classList.remove("error");
      }
    });
  });
  document.querySelectorAll('input[type="checkbox"]').forEach((input) => {
    input.addEventListener("change", () => {
      input.parentElement.querySelector("span")?.classList.remove("error");
    });
  });

  // Маска для телефонного поля з валідацією
  document.querySelectorAll('input[type="tel"]').forEach((input) => {
    const mask = IMask(input, {
			mask: '+{380} (00) 000-00-00',
		});
		

    // Перевірка, чи правильно введений номер, та додавання/зняття класу error
    input.addEventListener("input", () => {
			if(mask.unmaskedValue.slice(0, 3)[2]!=="0" && mask.unmaskedValue.slice(0, 3)[2]){
				console.log(mask.unmaskedValue.slice(0, 3)[2]);
				const newInput = mask.unmaskedValue.slice(2);
				mask.unmaskedValue = "380" + newInput;
			}
      if (mask.unmaskedValue.length == 12) {
        input.classList.remove("error");
      }
    });
  });
});
